import { css } from '@emotion/core'

export const getFullScreenifyCss = () => {
  const fullScreenifyCss = css`
    width: 100%;
    height: calc(var(--layout-viewport-height, 100vh) - var(--header-height, 60));
    overflow-y: auto;
    display: flex;
    flex-direction: column;
  `
  return fullScreenifyCss
}

export const getFullScreenifyCssBase = () => {
  const fullScreenifyCss = css`
    width: 100%;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    position: relative;
  `
  return fullScreenifyCss
}

export const getFullScreenifyHeight = (viewportHeight, extraOffset = 0) => {
  const fullScreenifyCss = css`
    height: calc(${viewportHeight}px - var(--header-height, 60) - ${extraOffset}px);
  `

  // Get a plain javascript object with the values we need so that we can put it into a style prop
  const cssStyles = fullScreenifyCss.styles
  const stylesObject = {}
  cssStyles.split(';').forEach((style) => {
    const [property, value] = style.split(':').map((s) => s.trim())
    if (property && value) {
      stylesObject[property] = value
    }
  })

  return stylesObject
}

/**
 * Calculates a scaled font size according to how long the text is
 *
 * @param {*} length - current length of the text
 * @param {*} minSize - min font size
 * @param {*} maxSize - max font size
 * @param {*} minSizeLength - length to use minSize
 * @param {*} maxSizeLength - length to use maxSize
 * @returns {number} font size
 */
export function calcScaledFontSize(length, minSize, maxSize, minSizeLength, maxSizeLength) {
  if (length <= minSizeLength) return maxSize
  if (length >= maxSizeLength) return minSize

  const scale = (length - minSizeLength) / (maxSizeLength - minSizeLength) // value from 0 to 1
  return maxSize - scale * (maxSize - minSize)
}
